var exports = {
  "W": "VoiceP2pConsentModal.module__points___YktyNW",
  "m": "VoiceP2pConsentModal.module__checkboxLabel___YktyNW",
};

module.exports = exports;
